import { type LegalEntitySummary } from '../LegalEntitySummary'
import { type PrimaryCategory } from '../PrimaryCategory'

export interface SecondaryCategoryConstructor {
  id: number
  name: string
  primaryCategory: Nullable<PrimaryCategory>
  legalEntity?: Nullable<LegalEntitySummary>
}

export class SecondaryCategory {
  id: number
  name: string
  primaryCategory: Nullable<PrimaryCategory>
  legalEntity?: Nullable<LegalEntitySummary>

  constructor(data: SecondaryCategoryConstructor) {
    this.id = data.id
    this.name = data.name
    this.primaryCategory = data.primaryCategory
    this.legalEntity = data.legalEntity ?? null
  }

  get nameWithPrimaryCategory(): string {
    return this.primaryCategory?.name
      ? `${this.primaryCategory.name} - ${this.name}`
      : this.name
  }
}
